const PEER_CONFIG = {
  host: process.env.VUE_APP_SIGNALING_HOST,
  port: process.env.VUE_APP_SIGNALING_PORT,
  secure: process.env.NODE_ENV !== 'development',
  iceServers: [
    { 'urls': 'stun:13.112.236.51:80' },
    { 'urls': 'turn:13.112.236.51:80?transport=tcp', 'username': 'ice-willies-english','credential': 'a12hK0tE9zak~LyR' }
  ]
}

export default PEER_CONFIG
